import React from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';

export const YouTubeBody = (props: { videoId: string; onClose: () => void }) => {
  const { videoId, onClose } = props;
  const onPlayerReady: YouTubeProps['onReady'] = (event) => {
    event.target.playVideo();
  };

  const opts: YouTubeProps['opts'] = {
    display: 'block',
    playerVars: {
      autoplay: 1,
    },
  };

  const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="attachments-view__main-container" onClick={handleContainerClick}>
      <div className="youtube-player-positioning-container">
        <YouTube
          loading="eager"
          videoId={videoId}
          onReady={onPlayerReady}
          iframeClassName="youtube-iframe"
          opts={opts}
        />
      </div>
    </div>
  );
};
